import { useLocation } from 'react-router-dom';
import { useHydrated } from '@/hooks/useHydrated';

/**
 * The query string a render may use: null while the prerendered markup hydrates
 * (the build rendered each page without one), the browser's own afterwards.
 * Null also means "no attribution yet": first-touch UTMs live in browser storage.
 */
export function useBrowserSearch(): string | null {
  const { search } = useLocation();
  return useHydrated() ? search : null;
}
